module.exports = __webpack_public_path__ + "media/npc_dota_hero_dark_willow.79937b68.webm";